const loadGMaps = cb => new Promise(resolve => {
  const existingScript = document.getElementById('gmap') || window.google?.maps;

  if (existingScript) {
    cb?.();
    resolve();
  } else {
    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyC4-CdZbkRjloADRGzjPgO8jhIXQMcewIM&libraries=&v=beta&map_ids=37b8978b7330d764';
    script.id = 'gmap'; // e.g., googleMaps or stripe
    document.body.appendChild(script);

    script.onload = () => {
      cb?.();
      resolve();
    };
  }
})

// App Data
let map;
let markers = [];
let infoBoxes = [];
let dates = [];
let icons = {
  retail: '/wp-content/themes/vestapoint/public/images/icon-retail.svg',
  multifamily: '/wp-content/themes/vestapoint/public/images/icon-multifamily.svg',
};

// App State
let dateRange = [0, Infinity];

export default function useTimelineMap(el) {
  const investmentTimelineEl = el || document.getElementById("investment-timeline");

  if (!investmentTimelineEl) return;

  // Grab data from dataset
  const investmentsUnsorted = investmentTimelineEl.dataset.investments || window.investments || [];

  let TOP = 'Multifamily'
  const investments = investmentsUnsorted.sort((a, b) => {
      if (a.projectType === b.projectType) {
        const dateA = new Date(a.date), dateB = new Date(b.date);
        return dateA === dateB ? 0 : (dateA > dateB ? 1 : -1);
      }

      return a.projectType == TOP ? 1 : b.projectType == TOP ? -1 : 0;
  })

  // Format raw data into composed marker and infobox data
  const markerData = investments.map(formatInvestmentData);

  // Extract usable dates from provided date strings
  dates = investments.map(formatInvestmentDates)

  // Load Maps API (if necessary)
  return new Promise((resolve, reject) => {
    loadGMaps().then(() => {
      if (!window.google?.maps) reject();
    
      // Make the thing happen
      // initIcons();
      initMap(investmentTimelineEl, markerData);
    
      resolve({
        instance: map,
        destroy: destroyMap,
        setMapDateRange,
        onRangeInput,
        viewAllMarkers,
      })
    }).catch(res => { console.log(res); reject(res); });
  })
}

/**
 * Format ACF Investment data for Google Maps
 * @param {Record<String,String|Number>} ACFData 
 * @returns {Record<String,String|Number>} GMapData
 */
const formatInvestmentData = ({
  lat, lng,
  address, city, state,
  title, description, image,
  projectType,
  date,
}) => {
  const content = [
    '<div class="prose prose-sm">',
    // Property Photo
    image
      ? `<img src="${image}" style="float:right;width: 50%;max-width:250px;margin:0 0 10px 10px;">`
      : '',

    // Infobox title
    title
      ? `<h1 id="firstHeading" class="firstHeading" style="margin-bottom: 0;">${title}</h1>`
      : `<h2 id="firstHeading" class="firstHeading" style="margin-bottom: 0;">${address}</h2>`,

    // Location
    `<h4 style="margin-top: 0">${
      (title ? (address + ', ') : '') + city + ', ' + state
    }</h4>`,

    // Bloop
    `<p>Property Type: ${projectType}</p>`,
    `<p>Date: ${date}</p>`,

    // ACF WYSIWYG Content
    description ? `<p>${description}</p>` : '',
    '</div>',
  ].join('')

  return {
    position: { lat, lng },
    title: (projectType || '') + ' - ' + (title || (address + ', ' + city + ', ' + state)),

    // Use first letter of project type for label
    label: projectType?.[0] || undefined,
    content,
  }
}

/**
 * Format date string as usable date
 * @param {Record<String, any>} ACFDateInfo
 * @returns {Record<String, any>} GMapsDateInfo
 */
const formatInvestmentDates = ({ date, year }) => {
  let d = new Date(date + ' UTC');

  return {
    time: d.getTime(),
    year,
  }
}

/** Initialize Google Map */
const initMap = (el, markerDataSet) => {
  const maps = window.google?.maps
  if (!maps) return;

  // Set in United States
  const usCenter = { lat: 39.81, lng: -98.556 };
  // const usBounds = { north: 49.38, south: 25.82, east: -66.94, west: -124.39 }
  const usContinent = { north: 52, south: 22, east: -64, west: -129 }

  map = new maps.Map(el, {
    zoom: 4,
    center: usCenter,
    // fitBounds: { bounds: usBounds },
    restriction: { latLngBounds: usContinent, strictBounds: false },
    // Use grayscale map style (managed under fiwi@gmail)
    mapId: '37b8978b7330d764',
  });
  const bounds = new maps.LatLngBounds(
    new maps.LatLng(25.82, -124.39),
    new maps.LatLng(49.38, -66.94)
  );
  map.fitBounds(bounds);

  if (!infoBoxes?.length) {
    markerDataSet.forEach(addInfo)
  } else {
    // Make sure cached infoboxes are assigned to the new map
    infoBoxes.forEach(infobox => infobox?.setMap?.(map))
  }

  if (!markers?.length) {
    markerDataSet.forEach(addMarker)
  }

  setMapDateRange(dateRange)
}

const destroyMap = () => {
  map = undefined;
  markers = [];
  infoBoxes = [];
  dates = [];
}

/** Create and push Infobox */
const addInfo = ({ content }) => {
  const maps = window.google?.maps
  if (!maps) return;

  const marker = new maps.InfoWindow({ content });
  infoBoxes.push(marker);
}

/** Create and push Marker with Infobox listener */
const addMarker = ({ position, title, label }) => {
  const maps = window.google?.maps
  if (!maps) return;

  const marker = new maps.Marker({
    position,
    title,
    map,
    icon: label == 'M'
      ? icons.multifamily
      : icons.retail,
    // animation: maps.Animation.DROP,
    visible: false,
    zIndex: label == 'M' ? 9999 : undefined,
  });

  var i = markers.length
  marker.addListener('click', () => { infoBoxes[i].open(map, marker) });

  markers.push(marker);
}

const YEAR_IN_MS = 31536000315
const onRangeInput = (event) => {
  const time = parseInt(
    // Let's handle like 4 kinds of events so we don't have to think about it
    event?.target?.value || event?.detail?.value || event?.value || event
  ) ?? 0
  const minTime = 0 // time - YEAR_IN_MS * 2
  const maxTime = time;
  dateRange = [minTime, maxTime];
  setMapDateRange(dateRange)
}

const viewAllMarkers = () => {
  markers.forEach(marker => {
    marker.setVisible(true);
    marker.setOpacity(1);
    // marker.setZIndex(undefined);
  })
}

const setMapDateRange = ([minTime, maxTime]) => {
  dates.forEach(({ time }, i) => {
    const shouldBeVisible = minTime <= time && time <= maxTime

    // Keep properties within one year fully visible, fade out for a quarter year
    const opacity = shouldBeVisible
      ? (
        time >= (maxTime - YEAR_IN_MS)
          ? 1
          : (time >= (maxTime - YEAR_IN_MS * 1.25) ? 0.95 : 0.9)
        )
      : 0

    const opaque = opacity === 1

    if (shouldBeVisible !== markers[i].visible) {
      markers[i].setVisible(shouldBeVisible);
    }

    if (shouldBeVisible && (opacity !== !!markers[i].opacity)) {
      markers[i].setOpacity(opacity);
      // markers[i].setZIndex(opaque ? 99999 : undefined);
    }
  })
}